<template>
  <section>
    <b-row>
      <b-col md="12">
        <h2>Roles <small v-if="$auth.can('agregar_roles')">
            <b-link href="" @click.prevent="agregar">Agregar</b-link>
          </small></h2>
        <b-table responsive striped hover :items="roles" :fields="campos">
          <template #cell(acciones)="row">
            <b-link href="" @click.prevent="editar(row.item)" v-if="$auth.can('editar_roles')">Editar</b-link>
            <b-link href="" @click.prevent="eliminar(row.item)" v-if="$auth.can('eliminar_roles')">Eliminar</b-link>
          </template>
        </b-table>
      </b-col>
    </b-row>
    <b-modal v-model="mainModal" size="lg" no-close-on-backdrop>
      <b-form ref="mainForm" @submit.prevent="guardar">
        <b-form-group label="Nombre:" label-for="input-nombre" :invalid-feedback="errores.nombre">
          <b-form-input id="input-nombre" v-model="rol.nombre" :state="$empty(errores.nombre)" trim></b-form-input>
        </b-form-group>
        <b-form-group label="Descripción:" label-for="input-descripcion" :invalid-feedback="errores.descripcion">
          <b-form-input id="input-descripcion" v-model="rol.descripcion" :state="$empty(errores.descripcion)" trim></b-form-input>
        </b-form-group>
        <b-form-group label="Permisos:" :invalid-feedback="errores.permisos">
          <b-form-checkbox-group v-model="rol.permisos" :state="$empty(errores.permisos)" stacked>
            <template v-for="(permiso, id) in permisos">
              <b-form-checkbox :key="id" :value="id">{{ permiso.etiqueta }}</b-form-checkbox>
              <template v-if="permiso.permisos">
                <b-form-checkbox class="ml-4" v-for="(permiso, id) in permiso.permisos" :key="id" :value="id">{{ permiso }}</b-form-checkbox>
              </template>
            </template>
          </b-form-checkbox-group>
        </b-form-group>
      </b-form>
      <template #modal-footer="{ cancel }">
        <b-button variant="success" @click="submit()">
          OK
        </b-button>
        <b-button variant="danger" @click="cancel()">
          Cancel
        </b-button>
      </template>
    </b-modal>
  </section>
</template>

<script lang="ts">
import axios from 'axios'
import { Vue, Component } from 'vue-property-decorator'

import { url } from '../../../services/url_service'

@Component
export default class Roles extends Vue {
  public mainModal: boolean = false
  public errores: any = {}
  public id?: number = null
  public rol: any = {
    permisos: [],
  }
  public roles: any = []
  public permisos: any = []
  public campos: any = [
    {
      key: 'nombre',
    },
    {
      key: 'descripcion',
      label: 'Descripción',
    },
    {
      key: 'acciones',
    },
  ]
  public submit() {
    (this.$refs.mainForm as Element).dispatchEvent(new window.Event('submit'))
  }
  
  public async cargarRoles() {
    let response = await axios.get(url.create('/internal/roles'), {
      params: {
        limit: 1000
      }
    })
    this.roles = response.data.data
  }
  public async cargarPermisos() {
    let response = await axios.get(url.create('/internal/roles/permisos'))
    this.permisos = response.data
  }
  public async agregar() {

    this.errores = {}
    this.mainModal = true
    this.id = null
    this.rol = {
      permisos: [],
    }
  }
  public async editar(rol) {
    this.errores = {}
    this.mainModal = true
    this.id = rol.id
    this.rol = {
      nombre: rol.nombre,
      descripcion: rol.descripcion,
      permisos: rol.permisos,
    }
  }
  public async eliminar(rol) {
    try {
      if (await this.$bvModal.msgBoxConfirm('¿Está seguro de que desea eliminar este rol?')) {
        await axios.delete(
          url.create(`/internal/roles/${rol.id}`)
        )
        this.cargarRoles()
      }
    } catch (ex) {
      this.$bvModal.msgBoxOk('No se pudo elminar este rol', { okVariant: 'danger', })
    }
  }
  public async guardar() {
    try {
      this.errores = {}
      let promise = this.id
        ? axios.put(url.create(`/internal/roles/${this.id}`), this.rol)
        : axios.post(url.create(`/internal/roles`), this.rol)
      let response = await promise
      this.mainModal = false
      this.cargarRoles()
    } catch (ex) {
      this.errores = ex.response.data
    }
  }
  created() {
    this.cargarRoles()
    this.cargarPermisos()
  }
}
</script>

<style lang="scss">
h2 small {
  font-size: 1rem;
}
</style>